var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fc-section",class:[
    ("fc-section--bg-" + _vm.bgColor),
    ("fc-section--padding-" + _vm.paddingSize) ]},[(!_vm.noContainer)?_c('div',{class:_vm.containerSize},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }